/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.booking').directive('gccsPopupBookingInfoComments', () => {
  return {
    restrict: 'A',
    controller: 'PopupBookingInfoCommentsController',
    controllerAs: 'bookingInfoCommentsCtrl',
    template: require('./template.pug'),
    scope: {
      booking: '<',
      onCommentsCountChange: '&'
    }
  };
});
